import { render } from "./Xclose.vue?vue&type=template&id=63771f0e"
import script from "./Xclose.vue?vue&type=script&setup=true&lang=js"
export * from "./Xclose.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Xclose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63771f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63771f0e', __exports__)) {
    api.reload('63771f0e', __exports__)
  }
  
  module.hot.accept("./Xclose.vue?vue&type=template&id=63771f0e", () => {
    api.rerender('63771f0e', render)
  })

}


export default __exports__